import { render, staticRenderFns } from "./CoaLiquid.vue?vue&type=template&id=f1c10b40&scoped=true&"
import script from "./CoaLiquid.vue?vue&type=script&lang=js&"
export * from "./CoaLiquid.vue?vue&type=script&lang=js&"
import style0 from "./CoaLiquid.vue?vue&type=style&index=0&id=f1c10b40&prod&lang=scss&scoped=true&"
import style1 from "./CoaLiquid.vue?vue&type=style&index=1&id=f1c10b40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c10b40",
  null
  
)

export default component.exports